// extracted by mini-css-extract-plugin
module.exports = {"success":"Success_success_1YmpM","desc":"Success_desc_3ajKl"};
    if(module.hot) {
      // 1789136759005
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  